<template>
	<div class = 'wechat-wrap'>
	<cIndex  ref="header"></cIndex>
		<div class="payWeChat-content">
			<h2>正在使用即时交易，30分钟后交易关闭</h2>
			<ul class="payWechat-transaction">
				<li>脑能力测评订单-<b>{{payName}}</b>，共<b>{{payPprice}}</b>元 </li>
				<li>收款方：<b>北京智精灵科技有限公司</b></li>
				<li>订单号：<b>{{ordernumberpay}}</b></li>
			</ul>
			<p>应付金额<span class="payMoneyY">{{payPprice}}</span>元</p>
			<ul class="wechart-money">
				<li><div class="wechat-border"><img :src = 'imgSrc'></div><span class="wechat-Message">请使用微信扫一扫，扫描二维码支付</span></li>
				<li><img src="../assets/weChatLogo.png" class="phonelOGO"></li>
			</ul>
		</div>
		<!-- <span class = "wenhao">【？】</span> -->
	</div>
</template>
<script>
 import cIndex from'@/components/header'
	const components = {
		cIndex
	}
	export default{
		components: components,
		data(){
			return{
				imgSrc:'',
				payName:'',
				payPprice:'',
				ordernumberpay:''
			}
		},//data
		mounted() {
			this.ordernumberpay = localStorage.getItem('orderNumber')
			this.$http.post(urls.urltest + "/order/getOrderInfo.json",{
				ordernumber:this.ordernumberpay,
				token:localStorage.getItem('token')
			}).then(function(res){
				this.payName = res.body.packageName
				this.payPprice = res.body.tcprice
			})
		},
		created(){
				var ordernumberWechat = localStorage.getItem('orderNumber');
				var imgSrc = urls.urltest + "/wxpay/qrcode"+'?ordernumber='+ordernumberWechat
				this.imgSrc = imgSrc
				var j = setInterval(() => {
		　　　　　　this.$http.post(urls.urltest + "/wxpay/hadPay",{
					token: localStorage.getItem('token'),
					ordernumber:ordernumberWechat,
					}).then(function(res){
						if(!res.body == ''){
							clearInterval(j)
							this.$router.replace("/successfulpayment"+'?out_trade_no='+res.body)
						}else{
							return false;
						}
					})
		　　　　}, 2000)
				window.onbeforeunload = function(){
				  clearInterval(j)
				  }
		}
	}
</script>
<style lang = 'scss'>
	@import "../styles/core/reset.scss";
	.wechat-wrap{
		position: relative;
		@include flexbox;
		@include flex-direction(column);
		.payWeChat-content{
			width: 12.00rem;
			background: #ffffff;
			margin: .2rem auto;
			box-shadow: 0 0 3px #C3C3C3;
			h2{
				font-family: PingFangTC-Regular;
				font-size: 20px;
				color: #555555;
				padding-top: 0.44rem;
				padding-left: 0.34rem;
				padding-bottom: 1rem;
				.wenhao{
					color: #467DE5;
				}
			}
			.payWechat-transaction{
				border-bottom: 1px dotted #999999;
				padding: 0 0 .16rem 0.34rem;
				@include flexbox;
				li{
					@include flex;
					font-family: PingFangTC-Regular;
					font-size: 0.16rem;
					color: #000000;
				}
			}
			p{
				padding: 0.69rem 0 0.23rem 2.47rem;
				font-family: PingFangTC-Regular;
				font-size: 20px;
				color: #000000;
				.payMoneyY{
					color: #f00;
					font-size: 0.24rem;
					padding:0 0.12rem;
				}
			}
			.wechart-money{
				padding: 0 0 .16rem 2.05rem;
				@include flexbox;
				li{
					@include flex;
					.wechat-border{
					   height: 3.33rem;
						width: 3.33rem;
						border: 1px solid #999999;
						img{
							height: 100%;
							width: 100%;
						}
					}
					
					.phonelOGO{

						height: 3.94rem;
						width: 3.21rem;
					}
					.wechat-Message{
						display: block;
						font-size: 20px;
						color: #555555;
						text-indent: 6px;
						padding-top:0.22rem;
						padding-bottom: 1.36rem;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// payWeChat.vue?f997d790